/*
 * External Merchandise List
 */

const values = [
  {
    title: 'THE WINSTON EFFECT: The Art & History of Stan Winston Studio',
    description:
      'The first-ever book to reveal the behind-the-scenes secrets of the groundbreaking work of Stan Winston Studio. Featuring an extensive array of sketches, production art, and photographs straight from the studio archives.',
    ctaUrl:
      'https://www.amazon.com/Winston-Effect-History-Stan-Studio/dp/1845761502',
    ctaContent: 'Buy on Amazon',
    photo: '/global/assets/images/store/book-merch.jpg',
    previewPhoto: '/global/assets/images/store/book-merch.jpg'
  }
]

export default values
